module.exports = __webpack_public_path__ + "img/z1.c0bf9948.png";